import { Box, Typography, Paper } from '@mui/material';
import { Business } from '@mui/icons-material';
import { motion } from 'framer-motion';

const Networks = () => {
  return (
    <Box sx={{ p: 3 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h4" component="h1" gutterBottom fontWeight={700}>
          Networks
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          Manage your barbershop networks and franchises
        </Typography>
        
        <Paper sx={{ p: 4, textAlign: 'center', mt: 3 }}>
          <Business sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            Network Management
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This feature is coming soon. You'll be able to manage your networks here.
          </Typography>
        </Paper>
      </motion.div>
    </Box>
  );
};

export default Networks;
